import { useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";
import SocialMediaIcons from "../../components/SocialMediaIcons";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <GameList />
      <SocialMediaIcons />
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomePage;
